// extracted by mini-css-extract-plugin
export var button = "SaveAndExitButton-module__button___ywKjV";
export var buttonText = "SaveAndExitButton-module__buttonText___G5VUt";
export var chevronLeftIcon = "SaveAndExitButton-module__chevronLeftIcon___Sb7fx";
export var column = "SaveAndExitButton-module__column___v3g9J";
export var errorMessage = "SaveAndExitButton-module__errorMessage___G5bKI";
export var spinnerWrapper = "SaveAndExitButton-module__spinnerWrapper___oXFps";
export var xboxGreen = "#107C10";